import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { PushpinOutlined } from '@ant-design/icons';

import styles from './stylesSortableItem.module.css';

import ToggleSwitch from '../../../../CommonComponents/ToggleSwitch/ToggleSwitch';
import ClipPath from '../../../../../assets/icons/ic_clip-path.svg';
import { useTogglePinLiveEvent } from '../../../../../queries/useTogglePinLiveEvent';
import { useToggleActiveLiveEvent } from '../../../../../queries/useToggleActiveLiveEvent';

const dateOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
};

const SortableItem = ({
  event,
  index,
  toggleStatus,
  togglePin,
  name,
  etype,
  columns,
  hideClipPath = false,
  sportId,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: event?.event_id });
  const { mutate: togglePinMutation } = useTogglePinLiveEvent();
  const { mutate: toggleStatusMutation } = useToggleActiveLiveEvent();

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: 'grab',
    filter: event.is_active ? 'none' : 'opacity(0.8)',
  };

  const getCountry = (competitors) => {
    const home = competitors?.find(({ qualifier }) => qualifier === 'home');
    return 'country' in home && home?.country;
  };

  const handlePinEvent = (event) => {
    togglePin({
      event_id: event.event_id,
      name: name,
    });

    togglePinMutation({
      entityId: event.entity_id,
      action: event.is_pinned ? 'unpin' : 'pin',
      sportId,
    });
  };

  const handleToggleStatus = ({ entity_id, event_status }) => {
    toggleStatusMutation({
      entityId: event.entity_id,
      isActive: !event_status,
      sportId,
    });
  };

  return (
    <>
      <tr
        ref={setNodeRef}
        style={style}
        {...attributes}
        className={`${styles.rowExpanded} ${styles.sortableItem} ${
          event.pinned_order ? styles.pinnedRow : styles.unPinnedRow
        }`}
      >
        {hideClipPath ? (
          <td className={styles.cell}></td>
        ) : (
          <td {...listeners}>
            <div className={styles.clipIconContainer}>
              <img src={ClipPath} alt="ClipPath" className={styles.clipIcon} />
            </div>
          </td>
        )}

        <td className={styles.cell}>
          <div className={styles.cellImage}>
            <div
              className={`${styles.pinIconContainer} ${
                event.pinned_order ? styles.pinnedIcon : styles.unPinnedIcon
              }`}
              onClick={() => handlePinEvent(event)}
            >
              <PushpinOutlined className />
              {!!event.pinned_order && <span className={styles.slash}>|</span>}
            </div>
            <span>#{event.event_id}</span>
          </div>
        </td>
        <td className={styles.cell}>
          <div className={styles.cellImage}>
            {/* <img src={event.image} alt="order" width={40} /> */}
            <span>
              {event.competitors
                ?.flatMap((competitor) => competitor.name)
                .join(' vs ')}
            </span>
          </div>
        </td>
        <td className={styles.cell}>
          <p>
            {new Date(event.scheduled_start_time).toLocaleString(
              'en-US',
              dateOptions
            )}
          </p>
        </td>

        <td className={styles.cell}>
          <div
            className={`${styles.status} ${
              event.event_status === 'live' ? `${styles.active}` : ''
            }`}
          >
            <span>{event.event_status}</span>
          </div>
        </td>
        <td className={styles.cell}>
          <p>{getCountry(event.competitors)}</p>
        </td>
        <td className={styles.cell}>
          <p></p>
        </td>
        <td className={styles.cell}>
          <p></p>
        </td>
        <td className={styles.cell}>
          <p></p>
        </td>
        <td className={styles.cell}>
          <ToggleSwitch
            status={event.event_status}
            eventCode={1}
            updateEventCode={handleToggleStatus}
            data={event}
            onlyUpdate={true}
          />
        </td>
        <td className={styles.cell}></td>
      </tr>
    </>
  );
};

export default SortableItem;
